export default __webpack_public_path__ + "static/media/example.b1f49989.png";